import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
  const [user, setUser] = useState({});

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, []);

  return (
    <>
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <Link to="/" className="brand-link">
          <img
            src="/dist/img/medinfo-logo.png"
            alt="logo"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8" }}
          />
          <span className="brand-text font-weight-light">ManPower Info</span>
        </Link>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <img
                src="/dist/img/person-icon.png"
                alt="User"
                className="img-circle elevation-2"
              />
            </div>
            <div className="info">
              <Link to="/users/profile" className="d-block">
                {user.name}
              </Link>
            </div>
          </div>
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
              <li className="nav-item has-treeview menu-open">
                <Link to="/" className="nav-link">
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>Dashboard</p>
                </Link>
              </li>

              {user.role === "admin" && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon far fa-user" />
                    <p>
                      Users
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item ml-2">
                      <Link to="/users/new" className="nav-link">
                        <i className="fas fa-user-plus nav-icon" />

                        <p>Add New</p>
                      </Link>
                    </li>
                    <li className="nav-item ml-2">
                      <Link to="/users" className="nav-link">
                        <i className="fas fa-users nav-icon" />
                        <p>All Users</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* tree */}
              {/* <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <i className="nav-icon fab fa-wpforms" />
                  <p>
                    Forms
                    <i className="right fas fa-angle-right" />
                  </p>
                </Link> */}
                {/* <ul className="nav nav-treeview"> */}
                  {(user.role === "admin" ||
                    user.role === "medical" ||
                    user.role === "spectator" || 
                    user.role === "callcenter") && (
                    <li className="nav-item has-treeview">
                      <Link to="#" className="nav-link">
                        <i className="fas fa-file-medical nav-icon" />
                        <p>
                          Medical
                          <i className="right fas fa-angle-right" />
                        </p>
                      </Link>
                      <ul className="nav nav-treeview">
                        {(user.role === "admin" || user.role === "medical") && (
                          <li className="nav-item ml-2">
                            <Link to="/forms/medical/new" className="nav-link">
                              <i className="far fa-plus-square nav-icon" />
                              <p>Add New</p>
                            </Link>
                          </li>
                        )}
                        <li className="nav-item ml-2">
                          <Link to="/forms/medical" className="nav-link">
                            <i className="fas fa-book-medical nav-icon" />
                            <p>All Medical Data</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}

                  {(user.role === "admin" ||
                    user.role === "broker" ||
                    user.role === "spectator" ||
                    user.role === "callcenter" ) && (
                    <li className="nav-item has-treeview">
                      <Link to="#" className="nav-link">
                        <i className="far fa-handshake nav-icon" />
                        <p>
                          Broker
                          <i className="right fas fa-angle-right" />
                        </p>
                      </Link>
                      <ul className="nav nav-treeview">
                        {user.role !== "spectator" && (
                          <li className="nav-item ml-2">
                            <Link to="/forms/broker/new" className="nav-link">
                              <i className="far fa-plus-square nav-icon" />
                              <p>Add New</p>
                            </Link>
                          </li>
                        )}
                        <li className="nav-item ml-2">
                          <Link to="/forms/broker" className="nav-link">
                            <i className="fas fa-briefcase nav-icon" />
                            <p>All Broker Data</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}
                {/* </ul> */}
              {/* </li> */}

              {user.role === "admin" && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-tablet-alt" />
                    <p>
                      App Users
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    {/* <li className="nav-item ml-2">
                      <Link to="/users/new" className="nav-link">
                        <i className="fas fa-user-plus nav-icon" />

                        <p>Add New</p>
                      </Link>
                    </li> */}
                    <li className="nav-item ml-2">
                      <Link to="/users/app" className="nav-link">
                        <i className="fas fa-users nav-icon" />
                        <p>All Users</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {user.role === "admin" && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-list-ol" />
                    <p>
                      Visa List
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item ml-2">
                      <Link to="/forms/visa/new" className="nav-link">
                        <i className="far fa-plus-square nav-icon" />
                        <p>Add New</p>
                      </Link>
                    </li>
                    <li className="nav-item ml-2">
                      <Link to="/forms/visa" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>All Visa</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {(user.role === "admin" || user.role === "medicalfitunfitrepoter" || user.role === "fitunfitrepoterdoctor" || user.role === "medicaladmin" || user.role === "doctor" || user.role === "xrayuploader") && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-x-ray" />
                    <p>
                      Medical Xray
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                  {( user.role === "admin" || user.role === "xrayuploader" || user.role === "medicaladmin") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/xray/new" className="nav-link">
                        <i className="far fa-plus-square nav-icon" />
                        <p>Add New Film</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitrepoter" || user.role === "medicaladmin" || user.role === "doctor" && user.email !== "jalalinicrh@gmail.com") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/xray" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>All New Film</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.email === "jalalinicrh@gmail.com" || user.role === "medicaladmin" || user.role === "medicalfitunfitrepoter") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/anotherxray" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>Another New Film</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicaladmin" || user.email === "jalalinicrh@gmail.com") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/xray/anotherrepoted" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>Another Reported Film</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.role === "medicaladmin" || user.role === "doctor" && user.email !== "jalalinicrh@gmail.com") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/xray/repoted" className="nav-link">
                          <i className="fas fa-file-signature nav-icon" />
                        <p>All Reported Film</p>
                      </Link>
                    </li>
                    )}
                  </ul>
                </li>
              )}


              {(user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitreportuploder" || user.role === "medicalfitunfitrepoter") && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-laptop-medical" />
                    <p>
                      Medical Report
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                  {( user.role === "admin" || user.role === "medicalfitunfitreportuploder") && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/medicalreport/new" className="nav-link">
                        <i className="far fa-plus-square nav-icon" />
                        <p>Add New Report File</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitreportuploder" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/fitunfit" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>All New Report</p>
                      </Link>
                    </li>
                    )}

                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitreportuploder" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/status/fit" className="nav-link">
                          <i className="fas fa-hiking nav-icon" style={{color: "green"}}/>
                        <p>All Fit Report</p>
                      </Link>
                    </li>
                    )}

                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/status/unfit" className="nav-link">
                          <i className="fas fa-file-signature nav-icon" style={{color: "red"}}/>
                        <p>All UnFit Report</p>
                      </Link>
                    </li>
                    )}

                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitreportuploder" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/status/inprogress" className="nav-link">
                          <i className="fas fa-spinner nav-icon" style={{color: "yellow"}}/>
                        <p>All In Progress</p>
                      </Link>
                    </li>
                    )}
                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/status/hold" className="nav-link">
                          <i className="fas fa-pause nav-icon" />
                        <p>All Hold Report</p>
                      </Link>
                    </li>
                    )}

                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitreportuploder" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/forms/status/holdvisit" className="nav-link">
                          <i className="fas fa-stop nav-icon" />
                        <p>All Visit Report</p>
                      </Link>
                    </li>
                    )}

                    {( user.role === "admin" || user.role === "fitunfitrepoterdoctor" || user.role === "medicalfitunfitrepoter" ) && (
                    <li className="nav-item ml-2">
                      <Link to="/trash" className="nav-link">
                          <i className="fas fa-trash-alt nav-icon" />
                        <p>Trash</p>
                      </Link>
                    </li>
                    )}
                  </ul>
                </li>
              )}


              {user.role === "admin" && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-list-ol" />
                    <p>
                      Lab Report
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item ml-2">
                      <Link to="/lab/addreport" className="nav-link">
                        <i className="far fa-plus-square nav-icon" />
                        <p>Add Lab Report</p>
                      </Link>
                    </li>
                    <li className="nav-item ml-2">
                      <Link to="/forms/labreport" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>All Lab Report</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {user.role === "admin" && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <i className="nav-icon fas fa-list-ol" />
                    <p>
                      Physical Exam Report
                      <i className="right fas fa-angle-right" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item ml-2">
                      <Link to="/physical/addreport" className="nav-link">
                        <i className="far fa-plus-square nav-icon" />
                        <p>Add Physical Report</p>
                      </Link>
                    </li>
                    <li className="nav-item ml-2">
                      <Link to="/forms/labreport" className="nav-link">
                        <i className="fas fa-file-alt nav-icon" />
                        <p>All Physical Report</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </>
  );
}
